export const GET_PURCHASE_COIN_HISTORY = "GET_PURCHASE_COIN_HISTORY";
